import React from 'react'

const UserDashboardProjects = () => {
	return <div>UserDashboardProjects</div>
}

export default UserDashboardProjects
